import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { TCommentId } from '../../../../../../../../store/model/card/types/IComment';
import { IGetState } from '../../../../../../../../types/types';
import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import {
    ESegmentClickType,
    ESegmentClickTypeEventOption,
} from '../../../../../../../../middlewares/segment/constants';
import { commentUpdate } from '../../../store/reducers/actions/commentUpdate';
import { getIsChatViewActive } from '../../../../../../../../store/router/selectors/getIsChatViewActive';
import { SegmentCardSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onEdit = (
    commentId: TCommentId,
    onOwnEdit: () => void,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.COMMENT_CLICKED, {
            name: ESegmentClickTypeEventOption.CLICK_TYPE,
            value: ESegmentClickType.double
        }, [{
            name: SegmentCardOptions.SOURCE,
            value: getIsChatViewActive(getState()) ? SegmentCardSourceValue.CHAT : SegmentCardSourceValue.CARD,
        }]));
        dispatch(commentUpdate({
            replyCommentId: null,
            replyAttachmentId: null,
            replyText: null,
            editCommentId: commentId,
        }));
        if (onOwnEdit) {
            onOwnEdit();
        }
    };

    return action;
};
